import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdateTableComponent } from './update-table.component';

const routes: Routes = [
  {
    path: '',
    component: UpdateTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpdateTableRoutingModule {}
